"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = require("lodash");
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var CustomHiddenUTM = props => {
  var field = props.field,
    fieldId = field.valueField.id,
    fieldName = field.valueField.name;
  var pageTitle,
    pageUrl = '';
  if (typeof window !== 'undefined') {
    pageTitle = document.title;
    var url = new URL(document.location.href);
    url.search = '';
    pageUrl = url.href;
  }
  var refreshCookie = props => {
    var utmParams = (0, _utils.getCookieJson)('UtmParms', true);
    var cm_mmc_value = (0, _utils.getCookieValue)('SemFormId');
    var utmFields = {};
    if (utmParams) {
      utmFields = utmParams;
    }
    //
    utmFields.seoTitle = pageTitle;
    utmFields.pageUrl = pageUrl;
    utmFields.CM_MMC = cm_mmc_value;
    props.onChange(fieldName, JSON.stringify(utmFields), true, []);
  };
  (0, _react.useEffect)(() => {
    (0, _lodash.delay)(refreshCookie, 5000, props);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
    id: fieldId,
    name: fieldName,
    type: "hidden",
    value: props.value
  }));
};
var _default = exports.default = CustomHiddenUTM;